module.exports = __webpack_public_path__ + "img/way_road.c57f5c09.svg";